import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EmailListItem, EmailDetail, EmailListResponse } from '../models/app.models';

@Injectable({ providedIn: 'root' })
export class EmailService {
  private apiUrl = '/api/emails';

  constructor(private http: HttpClient) {}

  getList(page = 1, pageSize = 20, search?: string, status?: number, linked?: boolean): Observable<EmailListResponse> {
    let params = new HttpParams().set('page', page).set('pageSize', pageSize);
    if (search) { params = params.set('search', search); }
    if (status != null) { params = params.set('status', status); }
    if (linked != null) { params = params.set('linked', linked); }
    return this.http.get<EmailListResponse>(this.apiUrl, { params });
  }

  getById(id: number): Observable<EmailDetail> {
    return this.http.get<EmailDetail>(`${this.apiUrl}/${id}`);
  }

  getForTransfer(transferId: number): Observable<EmailListItem[]> {
    return this.http.get<EmailListItem[]>(`/api/transfers/${transferId}/emails`);
  }

  link(emailId: number, transferId: number): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/${emailId}/link`, { transferId });
  }

  unlink(emailId: number, transferId: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${emailId}/link/${transferId}`);
  }
}
